<template>
  <div>
    <page-heading-info
    title="Jefferson County Emergency Management Agency"
    phone="(740) 264-4646"
    fax="(740) 266-4152"
    >
      <address-simple
      line1="300 Airport Road"
      line2="P.O. Box 2039"
      line3="Wintersville, OH 43953"
      ></address-simple>
    </page-heading-info>

  <div class="row">
    <!-- <div class="col-md-6 mt-3">
      <text-box-title title="Peeps">
      <div class="col-md-6 mt-3">
        <ul>
          <li>
            John Parker, EMA Director
          </li>
        </ul>
      </div>
    </text-box-title>
    </div> -->

    <div class="col mt-3">
      <text-box-title title="Mission Statement">
        <div class="col mt-3">
          <strong>To coordinate activities to mitigate, prepare for, respond to, and recover from disasters.</strong>
        </div>
      </text-box-title>

      <hr class="hr-weight" />
      <div class="mt-3">
        John Parker, EMA Director
        <br /><br />
        Rob Herrington, Deputy EMA Director
        <br /><br />
        Brenda Burkey, Administrative Clerk/Grants Coordinator
      </div>
    </div>
  </div>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    AddressSimple
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
  .hr-weight {
    background-color: #cecfd0;
    border: 0 none;
    color: #cecfd0;
    height: 2px;
  }
</style>